import { ACCEPT_REQUEST, DECLINE_REQUEST, GET_REQUEST } from "./request.constants";

export const getRequest = (payload, callback) => ({type: GET_REQUEST, payload, callback});
export const acceptRequest = (payload, callback) => ({type: ACCEPT_REQUEST, payload, callback});
export const declineRequest = (payload, callback) => ({type: DECLINE_REQUEST, payload, callback});